import React from 'react';
import './BenefitsOffered.css';
import { Link } from 'react-router-dom';
import { TrendingUp, Leaf, Wallet, ArrowRight } from 'lucide-react';

const BenefitsOffered = () => {
  return (
    <div className="bo-premium-section">
      <div className="bo-container">

        {/* Header */}
        <div className="bo-header">
          <span className="bo-subtitle">Why Choose ANT</span>
          <h2 className="bo-title">Unlock Your Farm's <span className="text-highlight">Full Potential</span></h2>
          <p className="bo-description">
            Experience the future of agriculture with our cutting-edge solutions designed to maximize yield,
            sustainability, and profitability.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="bo-grid">

          {/* Card 1: Productivity */}
          <div className="bo-card">
            <div className="bo-icon-box">
              <TrendingUp size={32} />
            </div>
            <h3 className="bo-card-title">Maximize Productivity</h3>
            <p className="bo-card-text">
              Leverage GPS-guided machinery, automated irrigation, and precision farming techniques to
              significantly boost your crop yields.
            </p>
          </div>

          {/* Card 2: Sustainability */}
          <div className="bo-card">
            <div className="bo-icon-box">
              <Leaf size={32} />
            </div>
            <h3 className="bo-card-title">Eco-Friendly Practices</h3>
            <p className="bo-card-text">
              Adopt sustainable methods like organic farming and integrated pest management to protect
              soil health and the environment.
            </p>
          </div>

          {/* Card 3: Cost Efficiency */}
          <div className="bo-card">
            <div className="bo-icon-box">
              <Wallet size={32} />
            </div>
            <h3 className="bo-card-title">Cost-Effective Solutions</h3>
            <p className="bo-card-text">
              Benefit from economies of scale, bulk production, and optimized resource usage to reduce
              operational costs and increase margins.
            </p>
          </div>

        </div>

        {/* CTA */}
        <div className="bo-cta-wrapper">
          <Link to="/benefitsdetails" className="bo-premium-btn">
            Explore All Benefits <ArrowRight size={18} className="ml-2" />
          </Link>
        </div>

      </div>
    </div>
  );
};

export default BenefitsOffered;
